import React, { useEffect, useState } from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

export default function PublicDocumentPage({ file }) {
  const [content, setContent] = useState('');
  const [failed, setFailed] = useState(false);
  useEffect(() => {
    const controller = new AbortController();
    setContent('');
    setFailed(false);
    fetch(`/terms/${file}`, { signal: controller.signal })
      .then(response => {
        if (!response.ok) throw new Error('Document unavailable');
        return response.text();
      })
      .then(setContent)
      .catch(error => { if (error.name !== 'AbortError') setFailed(true); });
    return () => controller.abort();
  }, [file]);
  return (
    <main style={{ padding: '20px', maxWidth: '800px', margin: '0 auto', fontFamily: 'Arial, sans-serif', lineHeight: 1.65 }}>
      {failed ? <p role="alert">页面暂时无法加载 / This page is temporarily unavailable. Please contact dream_core_support@163.com.</p> : <ReactMarkdown skipHtml remarkPlugins={[remarkGfm]}>{content}</ReactMarkdown>}
      <footer style={{ marginTop: '50px', textAlign: 'center', fontSize: '12px', color: '#999' }}>沪ICP备2025136834号-2</footer>
    </main>
  );
}
